import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import moment from 'moment';
import { isNullish } from '@/util/ds-util';
import ResourceFooterComponent from '@/shared/cards/briefing/resource/components/resource-footer/resource-footer.vue';
import { formatDateAgo } from '@/util/date-util';
import { getFacebookPostId, getFaviconByUrl, getXStatusId } from '@/util/common-util';

@Component({
  components: {
    'resource-footer': ResourceFooterComponent,
  },
  methods: { getFaviconByUrl, isNullish, formatDateAgo },
  computed: {
    moment() {
      return moment;
    },
  },
})
export default class SocialWidget extends Vue {
  @Prop(Object) readonly formModel: IResourceModel;
  @Prop(Boolean) readonly isHideOptions: boolean;
  @Prop(Boolean) readonly isHideAddReference: boolean;
  @Prop(Boolean) readonly isHideHidden: boolean;
  @Prop(Boolean) readonly isHideShared: boolean;
  @Prop(Boolean) readonly isHideGoover: boolean;

  @Emit('share') share() {}

  @Emit('hide') hide() {}

  @Emit('select-user-social') selectUserSocial() {}

  @Emit('view-detail') viewDetail() {}

  @Emit('toggle-resource') toggleResource() {}

  @Emit('add-to-reference') addToReference() {}

  @Emit('goover') goover() {}

  mounted() {}

  get postId() {
    if (this.formModel.url?.includes('x.com') || this.formModel.originParentDocDetail?.source_uri?.includes('x.com')) {
      return getXStatusId(this.formModel.originParentDocDetail.source_uri || this.formModel.url);
    }
    if (
      this.formModel.url?.includes('www.facebook.com') ||
      this.formModel.originParentDocDetail?.source_uri?.includes('www.facebook.com')
    ) {
      return getFacebookPostId(this.formModel.originParentDocDetail.source_uri || this.formModel.url);
    }
    return '@Anonymous';
  }

  get username() {
    const username = this.formModel.other_info?.userName;
    return username ? '@' + username : '';
  }

  get favicon() {
    if (this.formModel.url?.includes('x.com') || this.formModel.originParentDocDetail?.source_uri?.includes('x.com')) {
      return '/content/images/images_v4/common/go-icon-channel/x-twitter-circle.svg';
    }
    if (
      this.formModel.url?.includes('www.facebook.com') ||
      this.formModel.originParentDocDetail?.source_uri?.includes('www.facebook.com')
    ) {
      return '/content/images/images_v4/common/go-icon-channel/facebook.svg';
    }
    if (this.formModel.originParentDocDetail.source_uri_domain) {
      return `https://www.google.com/s2/favicons?domain=${this.formModel.originParentDocDetail.source_uri_domain}`;
    }
    return `https://www.google.com/s2/favicons?domain=${this.formModel.url}`;
  }
}
